import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import FunnelSteps from '../FunnelSteps';
import { FontSize14 } from '../fonts';
import { BaseText } from '../text';

import { Generic } from '../../i18n';

const BackText = styled(Link)`
    display: block;
    padding: 20px;
    ${BaseText};
    ${FontSize14};
`;

export default ({ backpath = '/', step = 0 }) => (

    <div className="row align-items-center" style={{ marginBottom: '70px' }}>
        
        <div className="col-4 col-md-2">
            <BackText to={backpath}>{Generic.back}</BackText>
        </div>

        <div className="col-12 col-md-6 col-lg-8 offset-md-1 offset-lg-0">
            <FunnelSteps step={step} />
        </div>
        
    </div>
    
);